export const verbiage = {
  EMAIL_TILE: 'Digital',
  SHIP_TITLE: 'Physical',
  FULFILLMENT_FILTER: 'Delivery Type',
  OCCASION_FILTER: 'Occasion',
  CATEGORIES_FILTER: 'Category',
  BRAND_FILTER: 'Brand'
};

export const PAGE_SIZE = 15;

export const THD_BRAND_NAME = 'The Home Depot';
export const FEATURED_BRANDS = 'Featured Brands';
export const DEFAULT_FEATURED_BRANDS = [
  THD_BRAND_NAME,
  'Grubhub',
  'Foot Locker',
  'Disney Gift Card',
  'Delta Air Lines',
  'Starbucks®'
];

export const FULFILLMENT_FILTERS = [verbiage.EMAIL_TILE, verbiage.SHIP_TITLE];

export const DEFAULT_FILTERS = {
  [verbiage.FULFILLMENT_FILTER.toLocaleLowerCase()]: FULFILLMENT_FILTERS
};

export const FILTER_NAMES = [
  verbiage.FULFILLMENT_FILTER,
  verbiage.OCCASION_FILTER,
  verbiage.CATEGORIES_FILTER,
  verbiage.BRAND_FILTER
];

export const BLOCKED_FILTERS = ['Best Sellers'];
export const PRESELECTED_OCCASION_FILTERS = ['Everyday'];
export const PRESELECTED_CATEGORY_FILTERS = [THD_BRAND_NAME];

export const error = {
  technicalError: 'Sorry, we\'re experiencing technical difficulties. Please try again later.'
};

export const VIEW_ALL_URL_BEST_SELLERS_THD = '/gift-cards/list?brand=The_Home_Depot';
export const THD_BRAND_EXCLUSIVE = 'The Home Depot Exclusive';
export const THIRD_PARTY_URL = 'https://www.homedepot.com/gift-cards/specialty-cards';
